import {
    initializePanelTelemetryData,
    loadPanel,
    panelClosed,
    panelLoaded,
} from '../actions/timePanelStoreActions';
import { orchestrator } from 'satcheljs';
import { preloadTimePanelData } from '../actions/publicActions';

export const loadPanelOrchestrator = orchestrator(loadPanel, async actionMessage => {
    initializePanelTelemetryData();
    panelLoaded(actionMessage.source);
});

export const panelClosedOrchestrator = orchestrator(panelClosed, () => {});

export const preloadTimePanelDataOrchestrator = orchestrator(preloadTimePanelData, async () => {
    await loadPanelData();
});

async function loadPanelData() {
    // any prefetch we can do to pre-load agenda view data should be done here, including calling pre-fetch functions from mogenda
}
